import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SFEntity, getContactFullName, formatContactDisplay } from '@shared/entities/salesforce-entity';
import { PartnerContactService } from '@shared/services/api/partner-contact.service';
import { Roles } from '@shared/models/types';
import { debounceTime, distinctUntilChanged, Observable, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'app-sf-contact-dialog',
  templateUrl: './sf-contact-dialog.component.html',
  styleUrls: ['./sf-contact-dialog.component.scss']
})
export class SfContactDialogComponent implements OnInit {
  searchTerm = '';
  filteredContacts: SFEntity[] = [];
  isLoading = false;
  selectedRole = '';

  private searchTerms = new Subject<string>();

  constructor(
    public activeModal: NgbActiveModal,
    private partnerContactService: PartnerContactService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => this.searchContacts(term))
      )
      .subscribe((results) => {
        this.filteredContacts = results;
        this.isLoading = false;
      });

    this.onSearchChange('');
  }

  onSearchChange(term: string): void {
    this.isLoading = true;
    this.searchTerms.next(term);
  }

  searchContacts(term: string): Observable<SFEntity[]> {
    if (this.selectedRole === Roles.CUSTOMER_PARTNER) {
      // CUSTOMER_PARTNER: tutti i record di SF_clienti_partner (sia Partner_c=true che false)
      return this.partnerContactService.searchAllPartnerContacts(term) as Observable<SFEntity[]>;
    }
    if (this.selectedRole === Roles.PARTNER) {
      // PARTNER: solo Partner_c = true
      return this.partnerContactService.searchPartners(term) as Observable<SFEntity[]>;
    }
    // CUSTOMER: cerca su SF_clienti_partner con isPartner=false, esclude già abilitati
    return this.partnerContactService.searchCustomerPartners(term) as Observable<SFEntity[]>;
  }

  selectContact(contact: SFEntity): void {
    this.activeModal.close(contact);
  }

  close(): void {
    this.activeModal.dismiss('cancel');
  }

  getContactFullName(contact: SFEntity): string {
    return getContactFullName(contact);
  }

  getContactEmail(contact: SFEntity): string {
    return contact.email || 'N/A';
  }

  getContactDisplay(contact: SFEntity): string {
    return formatContactDisplay(contact);
  }
}
